import { DialogActions, makeStyles } from '@material-ui/core';
import { Button, ModalV2, Text } from '.';

interface ActivateConfirmationModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const useStyles = makeStyles({
  actions: {
    padding: '32px 0 0',
  },
});

function ActivateConfirmationModal({
  open,
  onClose,
  onConfirm,
}: ActivateConfirmationModalProps) {
  const classes = useStyles();

  return (
    <ModalV2
      width='450px'
      open={open}
      onClose={onClose}
      titleProps={{
        title: 'Activate Status',
      }}>
      <Text variant='normal'>
        An invite to Traction5 will be sent when the status is changed to
        &quot;Active,&quot; if the person does not already have a Traction5
        account.
      </Text>
      <DialogActions className={classes.actions}>
        <Button
          variant='outlined'
          onClick={onClose}
          data-testid='button-cancel'>
          Cancel
        </Button>
        <Button onClick={onConfirm} data-testid='button-ok'>
          Ok
        </Button>
      </DialogActions>
    </ModalV2>
  );
}

export default ActivateConfirmationModal;


